
import { Component, signal, output, input, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'base-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss'],
  imports: [CommonModule]
})
export class CheckboxFilterComponent {
  private _docCount = signal<number>(0);
  private _label = signal<string>('');
  private _checked = signal<boolean>(false);
  private _type = signal<string>('');
  private _labelPadding = signal<boolean>(false);

  // Computed properties
  readonly uniqueId = computed(() => `${this._label()}_${this._type()}_${this.randNum}`);

  // Update output to use Angular 20 output() function
  checked = output<void>();

  randNum = Math.floor(Math.random() * 1000000000);

  doc_count = input<number>(0);
  label = input<string>('');
  isChecked = input<boolean>(false);
  type = input<string>('');
  labelPadding = input<boolean>(false);

  // Effects to handle input changes
  private docCountEffect = effect(() => {
    const value = this.doc_count();
    this._docCount.set(value);
  });

  private labelEffect = effect(() => {
    const value = this.label();
    this._label.set(value);
  });

  private isCheckedEffect = effect(() => {
    const value = this.isChecked();
    this._checked.set(value);
  });

  private typeEffect = effect(() => {
    const value = this.type();
    this._type.set(value);
  });

  private labelPaddingEffect = effect(() => {
    const value = this.labelPadding();
    this._labelPadding.set(value);
  });

}


